export const OrderFormField = {
  FirstName: 'firstName',
  LastName: 'lastName',
  BillingAddressCheckbox: 'billingAddressCheckbox',
  Address: 'address1',
  City: 'city',
  State: 'state',
  Zip: 'zip',
  SameAsShipping: 'sameAsShipping',
  Phone: 'phone',
  SecondaryPhone: 'secondaryPhone',
  Email: 'email',
  Notes: 'notes',
  Dealer: {
    Address: 'address',
    Email: 'email',
    Name: 'name',
    Phone: 'phone',
  },
  SalesRep: {
    Name: 'name',
  },
  Payment: {
    Name: 'name',
    AccountNumber: 'bankAccountNumber',
    RoutingNumber: 'bankLocationId',
    BankAccountType: 'bankAccountType',
  },
  Print: 'print',
  CompanyInformationSource: 'companyInformationSource',
  SelectedDealerKey: 'selectedDealerKey',
} as const;
